import React from 'react';
import { HeaderProvider } from './HeaderContext';
import { MainNavigation } from './MainNavigation/MainNavigation';
import { SecondLevelNavigation } from './SecondLevelNavigation/SecondLevelNavigation';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const Header = ({
  route,
  config
}) => /*#__PURE__*/_jsxs(HeaderProvider, {
  config: config,
  route: route,
  children: [/*#__PURE__*/_jsx(MainNavigation, {}), /*#__PURE__*/_jsx(SecondLevelNavigation, {})]
});